import { RefObject, useState } from 'react';
import axios from 'axios';
import { fitSVGToParent } from '../svg-util';

interface returnType {
  svg: string;
  fetchSVG: () => void;
  onSVGFetched: () => void;
}

const useSVG = (
  svgSrc: string,
  parentRef: RefObject<HTMLDivElement>,
  svgWrapperRef: any,
  scale?: number,
  onLoaded?: (scaleFactor: number, svgNode: SVGSVGElement | null) => void
): returnType => {
  const [svg, setSvg] = useState<string>('');

  const onSVGFetched = () => {
    const svgNode = getSvg();

    if (!svgNode) {
      return;
    }

    const { scaleFactor } = fitSVGToParent(svgNode, parentRef, scale);
    svgWrapperRef.current?.setAttribute('style', 'display: block;');
    onLoaded && onLoaded(scaleFactor, svgNode);
  };

  const getSvg = (): SVGSVGElement | null => svgWrapperRef.current?.querySelector('svg') || null;

  const fetchSVG = () => {
    axios
      .get(svgSrc)
      .then(({ data }) => {
        setSvg(data);
        onSVGFetched();
      })
      .catch((e) => console.log(e, 'error in fetch svg'));
  };

  return { svg, fetchSVG, onSVGFetched };
};

export default useSVG;
